import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import Connect from './Connect.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/messenger'),
    name: 'messenger_index',
    component: Index,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/messenger/new'),
    name: 'messenger_connect',
    component: Connect,
    meta: { permissions: ['administrator'] },
  },
];
